module.exports = __webpack_public_path__ + "static/media/alarm.95aec954.aac";